module.exports = __webpack_public_path__ + "media/images/coorum_icon_key-1c249f9e1f2442108315483dc86e6770.svg";